import {writable} from "svelte/store";

const photos = writable([]);

const next = photo => {
    let result;
    photos.subscribe(items => {
        let index = items.findIndex(itm => itm === photo);
        result = items[index+1] == null ? items[0] : items[index+1];
    })
    return result;
}

const previous = photo => {
    let result;
    photos.subscribe(items => {
        let index = items.findIndex(itm => itm === photo);
        result = items[index-1] == null ? items[items.length-1] : items[index-1];
    })
    return result;
}

const addPhoto = newPhoto => {
    photos.update(photoList => [...photoList, newPhoto])
}


export let album = {
    subscribe: photos.subscribe,
    set: photos.set,
    next,
    previous,
    addPhoto
}
